// extracted by mini-css-extract-plugin
module.exports = {"primary":"CircularProgress_primary__Cp08r","secondary":"CircularProgress_secondary__z8OGL"};